export const validLensTreatmentColumns = [
    {
        Header: "Name",
        accessor: "name",
        canFilter: true,
        filterPlaceholder: "Filter by name",
        width: 200,
    },
    {
        Header: "Category",
        accessor: "category",
        canFilter: true,
        filterPlaceholder: "Filter by category",
        width: 150,
    },
    {
        Header: "Cost",
        accessor: "cost",
        Cell: ({ value }) => value ? `$${parseFloat(value).toFixed(2)}` : '-',
        width: 100,
    },
    {
        Header: "Retail Price",
        accessor: "retailPrice",
        Cell: ({ value }) => value ? `$${parseFloat(value).toFixed(2)}` : '-',
        width: 120,
    },
    {
        Header: "Stackable",
        accessor: "isStackable",
        Cell: ({ value }) => value ? 'Yes' : 'No',
        width: 100,
    },
    {
        Header: "Status",
        accessor: "status",
        canFilter: true,
        filterPlaceholder: "Filter by status",
        width: 100,
    },
    {
        Header: "Description",
        accessor: "description",
        width: 250,
    },
];
